<template>
  <div id="app">
    <el-container>
      <!--- 头部信息 -->
      <el-header>
        <div class="logo">
          <img src="./assets/img/dby-logo.png" alt />
        </div>
        <el-menu
          background-color="#ffffff"
          text-color="#000000"
          active-text-color="#ffd04b"
          :default-active="defaultActive"
          class="menu"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item style="padding-right: 30px;" index="/">首页</el-menu-item>
          <!-- <el-menu-item style="padding-right: 30px;" index="/product">产品中心</el-menu-item> -->
          <el-menu-item style="padding-right: 30px;" index="/product_manual">产品手册</el-menu-item>
          <!-- <el-menu-item style="padding-right: 30px;" index="/serivce">服务与支持</el-menu-item> -->
          <!-- <el-menu-item style="padding-right: 30px;" index="/partner">合作伙伴</el-menu-item> -->
          <!-- <el-menu-item style="padding-right: 30px;" index="/about_us">关于我们</el-menu-item> -->
          <!-- 下面是不要的 -->
          <!-- <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/case">经典案例</el-menu-item>
          <el-menu-item index="/goin">走进顶佰熠</el-menu-item>
          <el-menu-item index="/download">下载APP</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main :style="defaultHeight">
        <router-view />
      </el-main>
      <!--- 底部信息 -->
      <div class="footer" v-show="handleSelect">
        <div class="footer-content">
          <ul class="content-contact">
            <!-- <li>
              <p>000-000-000</p>
              <span>售后服务热线</span>
              <p>000-000-000</p>
              <span>售后服务热线</span>
            </li> -->
          </ul>
          <ul class="content-ercode">
            <li>
              <img src="@/assets/img/ercode.png" />
              <span>微信公众号</span>
            </li>
          </ul>
          <ul class="content-nav">
            <li>
              <p>产品中心</p>
              <span>传统pos终端</span>
              <span>智能收银终端</span>
              <span>扫码支付终端</span>
              <span>外接设备终端</span>
            </li>
            <li>
              <p>产品手册</p>
              <span>产品查询</span>
            </li>
            <li>
              <p>服务与支持</p>
              <span>服务条款</span>
              <span>常见问题</span>
              <span>产品系列</span>
            </li>
            <li>
              <p>合作伙伴</p>
              <span>合作政策</span>
              <span>合作伙伴</span>
              <span>合作加盟</span>
            </li>
            <li>
              <p>关于我们</p>
              <span>公司简介</span>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>荣誉与资质</span>
              <span>社会责任</span>
              <span>人才招聘</span>
            </li>
          </ul>
        </div>
        <div class="copyright">
          <span>Copyright © 2024 厦门顶佰熠科技有限公司 版权所有</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      // <el-main>高度
      defaultHeight: {
        minHeight : ""
      }
    };
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  methods: {
    // 是否显示底部信息
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      console.log(this.isShow);
    },
    // 定义el-main高度
    getHeight() {
      this.defaultHeight.minHeight  = window.innerHeight - 60 + "px";
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.el-header {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  height: 60px;
  margin: 0;
  // 顶部导航栏背景颜色
  background-color: #ffffff;

  .logo {
    width: 280px;
    padding: 1px;
    margin-right: 50px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }

  .menu {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 17px;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 300px;
  overflow: hidden;
  background-color: #1d1d1d;
  &-content {
    //width: 1240px;
    margin: 0 350px;
    padding-top: 70px;
    display: flex;  
    justify-content: space-around;
    flex-direction: row;
    align-items: flex-start;
    .content-contact {
      display: flex;
      justify-content: space-around;
      padding-right: 80px;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: flex-start;
        p {
          padding: 0 0 5px 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 31px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        span {
          padding: 0 0 15px 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 17px;
          color: #999999;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
    .content-ercode {
      display: flex;
      justify-content: space-around;
      padding-right: 80px;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        span {
          padding: 0 0 15px 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 13px;
          color: #999999;
          line-height: 17px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        img {
          width: 130px;
          height: 130px;
          padding: 10px;
        }
      }
    }
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: flex-start;
        p {
          padding: 0 0 10px 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #5B5B5B;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        span {
          padding: 0 0 5px 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 13px;
          color: #C4C4C4;
          line-height: 18px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
  .copyright {
    height: 30px;
    background: #1d1d1d;
    margin: 0 350px 0 350px;
    display: flex;
    justify-content: center;
    span {
      padding: 0 0 0 20px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 12px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
